const state= {
    GLAccountItems:{
        data:[],
        total:0,
    },
    coa: [],
    masterGLAccount: []
};

const getters = {
    GLAccountItems : (state) => state.GLAccountItems,
    coa: state => state.coa,
    masterGLAccount: state => state.masterGLAccount
};


const actions = {
  async getGLAccountItems({commit}, params){
      let page = params.page || 1;
      let isCMS = params.isCMS || '';
      let limit = params.limit || -1;
      let filter = params.filter || null;
      let contract_id = params.contract_id || -1;
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/contract-gl-account`, {params: {
                  isCMS:isCMS,
                  page:page,
                  limit:limit,
                  filter:filter,
                  contract_id: contract_id
              }})
              .then(response => {
                  commit( 'SET_CONTRACT_GL_ACCOUNT', response.data.data );
                  resolve( response.data.data );
              })
              .catch(error => reject( error ));
      });
  },
  async getCOA({commit}, params){
      return new Promise((resolve, reject) => {
          global.axios.get(`api/chart-of-account`)
              .then(response => {
                commit( 'SET_COA', response.data.data );
                resolve(response.data.data);
              })
              .catch(error => reject(error));
      });
  },
  async getMasterGLAccount({commit}, params){
      return new Promise((resolve, reject) => {
          global.axios.get(`api/master-gl-account`)
              .then(response => {
                commit( 'SET_MASTER_GL_ACCOUNT', response.data.data );
                resolve(response.data.data);
              })
              .catch(error => reject(error));
      });
  },

  async saveGLAccount({commit}, params){
      return new Promise((resolve, reject) => {
        if(params.id){
          global.axios.put(`api/contract-gl-account/` + params.id,{
            contract_id: params.contract_id,
            gl_code: params.coa.gl_code,
            master_gl_account_id: params.masterGLAccount.id
          })
          .then(response => {
            resolve(response.data.data);
          })
          .catch(error => reject(error));
        }else{
          global.axios.post(`api/contract-gl-account`,{
            contract_id: params.contract_id,
            gl_code: params.coa.gl_code,
            master_gl_account_id: params.masterGLAccount.id
          })
          .then(response => {
            commit( 'CREATE_FM_CODE', response.data.data );
            resolve(response.data.data);
          })
          .catch(error => reject(error));
        }

      });
  },

  async deleteGLAccount({commit}, ids) {
    return new Promise((resolve, reject) => {
        global.axios.delete(`api/contract-gl-account`, {
            data: {
                ids: ids
            }
        })
        .then(response => {
            resolve(response);
        })
        .catch(error => reject(error));
    })
  }
}

const mutations = {
    SET_CONTRACT_GL_ACCOUNT (state, data) {
      state.GLAccountItems = data;
    },
    SET_COA(state, data){
      state.coa = data.items
    },
    SET_MASTER_GL_ACCOUNT(state, data){
      state.masterGLAccount = data.items
    },
    CREATE_FM_CODE(state, data){
      state.GLAccountItems = [...state.GLAccountItems.items, data];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
